import React from "react";
import { useLocation } from "react-router-dom";
import Fade from "@material-ui/core/Fade";

import Wrapper from "src/components/Wrapper";
import Menu from "./Menu";

function TransactionDetails({ children }) {
  const location = useLocation();

  return (
    <Wrapper>
      <Menu />
      <Fade key={location.pathname} in={true} timeout={400}>
        <div>{children}</div>
      </Fade>
    </Wrapper>
  );
}

export default TransactionDetails;
